export default function AnimatedBackground({ className = '' }) {
  return (
    <div className={`home-animated-bg${className ? ` ${className}` : ''}`} aria-hidden="true">
      <div className="home-animated-bg__base" />
      <div className="home-animated-bg__layer home-animated-bg__layer--1" />
      <div className="home-animated-bg__layer home-animated-bg__layer--2" />
      <div className="home-animated-bg__layer home-animated-bg__layer--3" />
      <div className="home-animated-bg__layer home-animated-bg__layer--4" />
      <div className="home-animated-bg__veil" />
    </div>
  );
}
